<script setup>
import "~/assets/css/main.css";
const websiteName = "Turboweb"; // Replace with your actual website name
const websiteDescription =
  "Nie trać klientów przez brak strony. Z TurboWeb ruszasz w sieci w 7 dni – z gotową, dopracowaną stroną, która wygląda świetnie i przyciąga klientów w Google i w Mapach."; // Replace with your actual website description

useSeoMeta({
  title: websiteName,
  description: websiteDescription,
});

const links = [
  { name: "Strona główna", path: "/" },
  { name: "Cennik", path: "/cennik" },
  {
    name: "Przydatne informacje",
    path: "/pomoc",
    children: [
      {
        name: "Co to jest Google Search Console i Google Analytics?",
        path: "/pomoc/co-to-jest-google-search-console-i-google-analytics",
      },
      { name: "Polityka prywatności", path: "/polityka-prywatnosci" },
    ],
  },
  { name: "Kontakt", path: "/kontakt", highlight: true },
];
const adress = "Miernicza 22/11 Wrocław 50-435";
const phone = "+48 600 785 127";
const email = "turboweb.pl@gmail.com";

const isOpen = ref(false);
</script>
<template>
  <FlexuilibNavDesktop
    class="p-4 lg:px-16 sticky top-0 bg-zinc-900 z-50"
    :links="links"
    @toggleMobile="isOpen = !isOpen"
    :style="{
      '--color-iq-paragraph-color': '#f3f4f6',
    }"
  >
    <template #logo>
      <Logo />
    </template>
  </FlexuilibNavDesktop>
  <FlexuilibNavMobile
    :links="links"
    logo="Flex Ui Lib"
    v-model="isOpen"
    class="md:hidden text-2xl p-2 rounded hover:bg-white/10 transition"
    aria-label="Toggle navigation"
  >
    <template #logo>
      <Logo />
    </template>

    <template #footer>
      <div class="mt-4 border-t border-white/20 pt-4 text-sm text-white/80">
        <p class="mb-2">
          <strong>Adres:</strong><br />
          {{ adress }}
        </p>
        <p class="mb-2">
          <strong>Telefon:</strong><br />
          <a :href="`tel:${phone}`" class="hover:underline">{{ phone }}</a>
        </p>
        <p>
          <strong>Email:</strong><br />
          <a :href="`mailto:${email}`" class="hover:underline">{{ email }}</a>
        </p>
      </div>
    </template>
  </FlexuilibNavMobile>
  <NuxtPage />

  <Footer2
    brandName="TurboWeb"
    :siteMap="[
      { label: 'Start', href: '/' },
      { label: 'Proces', href: '/proces-tworzenia-strony' },
      { label: 'Cennik', href: '/cennik' },
      { label: 'Przydatne informacje', href: '/pomoc' },
      { label: 'Kontakt', href: '/kontakt' },
    ]"
    :addressLines="['ul. Miernicza 22', '50-435 Wrocław, Polska']"
    phone="+48 600 785 127"
    email="turboweb.pl@gmail.com"
  />
</template>
